import GenericDB from './generic-db'

export default class AccountClientCampaignGoogleAdzDB extends GenericDB {
  constructor(accountId, clientId, campaignId) {
    super(`accounts/${accountId}/clients/${clientId}/campaigns/${campaignId}/googleAdz`)
  }

  // Here you can extend AccountClientCampaignGoogleAdzDB with custom methods
}
